import React from 'react';
import classNames from 'classnames';

import MContainer from 'views/MContainer/MContainer';

import classes from './MFormCard.module.scss';
import MButton from 'views/Buttons/MButton/MButton';
import { useTranslation } from 'react-i18next';
import { MButtonThemes } from 'views/Buttons/MButton/MButton.model';

type Props = {
  className?: string;
  header?: string | JSX.Element;
  bodyClassName?: string;
  headerClassName?: string;
  isFullScreen?: boolean;
  showToggler?: boolean;
  showBody: boolean;
  isSectionSubmitted?: boolean;
  onToggleClick: () => void;
};

const MFormCardView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <MContainer className={classNames(classes['container'], props.className, { [classes['container--separator']]: !props.isFullScreen })}>
      {props.header ? (
        <div className={classNames(classes['header'], props.headerClassName)}>
          {props.header}
          {props.showToggler && (
            <MButton
              disabled={props.isSectionSubmitted !== undefined ? props.showBody : false}
              type="button"
              className={classes['toggleButton']}
              onClick={props.onToggleClick}
              theme={props.isSectionSubmitted !== undefined ? MButtonThemes.Filled : MButtonThemes.Text}
            >
              {props.isSectionSubmitted !== undefined ? t('common.add') : '+'}
            </MButton>
          )}
        </div>
      ) : null}
      {props.children && props.header ? <div className={classes['separate']}></div> : null}
      {props.showBody && <div className={classNames(classes['body'], props.bodyClassName)}>{props.children}</div>}
    </MContainer>
  );
};

MFormCardView.displayName = 'MFormCardView';
MFormCardView.defaultProps = {};

export default MFormCardView;
